/**
 * Monta a pergunta que o botão "Explicar" de um alerta envia ao @Atendente.
 *
 * Diferente do prefill antigo (só "Sobre o alerta X: "), aqui geramos uma
 * pergunta COMPLETA — para o clique já iniciar uma conversa ativa (auto-envio),
 * pedindo explicação + causas prováveis + o que verificar.
 */

export interface AlertQuestionInput {
  body?: string | null
  metadata?: { trigger?: unknown; host?: unknown } | null
}

function _str(v: unknown): string | null {
  return typeof v === 'string' && v.trim().length > 0 ? v.trim() : null
}

export function buildAlertQuestion(input: AlertQuestionInput): string {
  const trigger = _str(input.metadata?.trigger)
  const body = _str(input.body)
  const host = _str(input.metadata?.host)
  const label = trigger ?? body

  const base = 'Explique este alerta, as causas prováveis e o que devo verificar'

  if (!label) {
    return `${base}.`
  }
  const hostPart = host ? ` no host ${host}` : ''
  return `${base}: "${label}"${hostPart}.`
}
